import { soadT3Part1DataSchema } from "../../schemas/index.js";
export const soadT3Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I am a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD), and have consulted",
            ],
        },
        // Consultees
        {
            type: "label",
            showStaticLabel: true,
            label: ["Consultee’s Full Name and Profession"],
        },
        {
            type: "readonly",
            textFn: (_data, context) => {
                const part4 = context.previousPartsFormData.find((s) => s.section === "consulteeDetails")?.data;
                const firstConsulteeName = part4?.firstConsulteeName?.trim();
                const firstConsulteeProfession = part4?.firstConsulteeProfession?.trim();
                const secondConsulteeName = part4?.secondConsulteeName?.trim();
                const secondConsulteeProfession = part4?.secondConsulteeProfession?.trim();
                return firstConsulteeName &&
                    firstConsulteeProfession &&
                    secondConsulteeName &&
                    secondConsulteeProfession
                    ? [
                        `${firstConsulteeName}, ${firstConsulteeProfession}`,
                        `${secondConsulteeName}, ${secondConsulteeProfession}`,
                    ]
                    : ["Please complete the Consultee Details section."];
            },
            afterLabel: "Taken from the ‘Consultee Details’ section which you completed earlier.",
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "who have been professionally concerned with the medical treatment of the patient named above.",
            ],
        },
        {
            type: "branch",
            label: "I certify that the patient",
            field: "patientCapability",
            branches: [
                {
                    fieldValue: "not-capable",
                    label: "is not capable of understanding the nature, purpose and likely effects of the following treatment",
                    fieldsOwned: [],
                    fields: [],
                },
                {
                    fieldValue: "not-consented",
                    label: "has not consented to the following treatment",
                    fieldsOwned: [],
                    fields: [],
                },
            ],
        },
        {
            type: "textbox",
            field: "treatment",
            label: "Enter description of treatment or plan of treatment. Include clearly if the certificate is only to apply to any or all of the treatment for a specific period.",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part5?.planAuthorisedMedication,
                        part5?.timeLimitCertificateDuration,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Treatment plan",
            },
        },
        {
            type: "label",
            showStaticLabel: true,
            label: ["but that it is appropriate for the treatment to be given"],
        },
        {
            type: "textbox",
            field: "reasons",
            label: "My reasons are as below",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part2 = context.previousPartsFormData.find((s) => s.section === "diagnosisAndHistory")?.data;
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [
                        part2?.diagnosis,
                        part2?.assessment,
                        part5?.timeLimitCertificateReason,
                        part5?.interimS61Reasons,
                    ]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Reasons",
            },
            afterLabel: "When giving reasons, please indicate if, in your opinion, disclosure of the reasons to the patient would be likely to cause serious harm to the physical or mental health of the patient, or to that of any other person.",
        },
        {
            type: "branch",
            field: "disclosureHarmful",
            label: "Would disclosure of these reasons to the patient be likely to cause serious harm to the physical or mental health of the patient, or of any other person?",
            afterLabel: "Recording yes adds a warning for anyone viewing this certificate. It does not appear on the certificate itself or the downloaded PDF.",
            branches: [
                { fieldValue: false, label: "No", fields: [], fieldsOwned: [] },
                { fieldValue: true, label: "Yes", fields: [], fieldsOwned: [] },
            ],
        },
    ],
    dataSchema: soadT3Part1DataSchema,
};
export const soadT3V1Base = {
    id: "mha-soad-t3",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "T3",
    section: "58(3)(b)",
    parts: [soadT3Part1Template],
    description: "Certificate of Second Opinion",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=soad-t3.js.map